//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

//结算批次维护管理
const batchList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/settlementBatch/list.vue')),
    'batchList'
  );
//结算批次创建
const batchAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/settlementBatch/add.vue')),
    'batchAdd'
  );
//结算批次修改
const batchEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/settlementBatch/edit.vue')),
    'batchEdit'
  );
//结算批次详情
const batchDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/settlementBatch/detail.vue')),
    'batchDetail'
  );
//结算单列表
const statementsList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/statements/list.vue')),
    'statementsList'
  );
//结算单创建
const statementsAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/statements/add.vue')),
    'statementsAdd'
  );
//结算单修改
const statementsEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/statements/edit.vue')),
    'statementsEdit'
  );
//结算单详情
const statementsDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/statements/detail.vue')),
    'statementsDetail'
  );
//结算汇总表列表
const summaryList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/settleSummary/list.vue')),
    'summaryList'
  );
//利率配置
const sbRateList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/rateConfig/list.vue')),
    'sbRateList'
  );
//利率配置创建
const sbRateAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/rateConfig/add.vue')),
    'sbRateAdd'
  );
//利率配置修改
const sbRateEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/rateConfig/edit.vue')),
    'sbRateEdit'
  );
//利率配置详情
const sbRateDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/settle/rateConfig/detail.vue')),
    'sbRateDetail'
  );

const settleRouter = {
  path: '/settle',
  component: index,
  children: [
    {
      path: 'batchList',
      name: 'batchList',
      component: batchList,
      meta: {
        keepAlive: true,
        title: '结算批次维护管理',
      },
    },
    {
      path: 'batchAdd',
      name: 'batchAdd',
      component: batchAdd,
      meta: {
        keepAlive: true,
        title: '结算批次创建',
      },
    },
    {
      path: 'batchEdit',
      name: 'batchEdit',
      component: batchEdit,
      meta: {
        keepAlive: true,
        title: '结算批次修改',
      },
    },
    {
      path: 'batchDetail',
      name: 'batchDetail',
      component: batchDetail,
      meta: {
        keepAlive: true,
        title: '结算批次详情',
      },
    },
    {
      path: 'statementsList',
      name: 'statementsList',
      component: statementsList,
      meta: {
        keepAlive: true,
        title: '结算单查询',
      },
    },
    {
      path: 'statementsAdd',
      name: 'statementsAdd',
      component: statementsAdd,
      meta: {
        keepAlive: true,
        title: '结算单创建',
      },
    },
    {
      path: 'statementsEdit',
      name: 'statementsEdit',
      component: statementsEdit,
      meta: {
        keepAlive: true,
        title: '结算单修改',
      },
    },
    {
      path: 'statementsDetail',
      name: 'statementsDetail',
      component: statementsDetail,
      meta: {
        keepAlive: true,
        title: '结算单详情',
      },
    },
    {
      path: 'summaryList',
      name: 'summaryList',
      component: summaryList,
      meta: {
        keepAlive: true,
        title: '结算汇总表',
      },
    },
    {
      path: 'sbRateList',
      name: 'sbRateList',
      component: sbRateList,
      meta: {
        keepAlive: true,
        title: '利率配置',
      },
    },
    {
      path: 'sbRateAdd',
      name: 'sbRateAdd',
      component: sbRateAdd,
      meta: {
        keepAlive: true,
        title: '利率配置创建',
      },
    },
    {
      path: 'sbRateEdit',
      name: 'sbRateEdit',
      component: sbRateEdit,
      meta: {
        keepAlive: true,
        title: '利率配置修改',
      },
    },
    {
      path: 'sbRateDetail',
      name: 'sbRateDetail',
      component: sbRateDetail,
      meta: {
        keepAlive: true,
        title: '利率配置详情',
      },
    },
  ],
};
export default settleRouter;
